var map = {
	"./404/index.vue": [
		"VdfP",
		12
	],
	"./centre/detail.vue": [
		"UvNg",
		4
	],
	"./centre/index.vue": [
		"D+cl",
		11
	],
	"./centre/item.vue": [
		"Inkd",
		13
	],
	"./home/index.vue": [
		"KR8f",
		6
	],
	"./interventionalVoice/detail.vue": [
		"V5zd",
		3
	],
	"./interventionalVoice/index.vue": [
		"OrJE",
		1
	],
	"./interventionalVoice/pageDetail.vue": [
		"iG33",
		5
	],
	"./main.vue": [
		"sRz/",
		8
	],
	"./patientEducation/detail.vue": [
		"4Ur4",
		7
	],
	"./patientEducation/index.vue": [
		"ntoi",
		2
	],
	"./therapy/detail.vue": [
		"JB0/",
		10
	],
	"./therapy/index.vue": [
		"kSJH",
		0
	],
	"./therapy/periodical.vue": [
		"NwQN",
		9
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*\.vue$
// module id = Opzk
// module chunks = 15